import { NumberWithUnit } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type SectionScoreBadgeProps = {
    value?: string | number | null;
    unit?: string;
};

/**
 * Per-section impact score tag from Product V2 empty and filled Figma states.
 * Live values and the Foods empty indicator share the same fixed-height surface.
 */
export const SectionScoreBadge = (props: SectionScoreBadgeProps) => {
    const { unit = "Pts" } = props;
    const value = props.value ?? null;
    const theme = useTheme();
    const { t } = useTranslation();
    const accessibleLabel =
        value === null ?
            t("product.v2.score.unavailable", "Score unavailable")
        :   [t("score", "Score"), value, unit].join(" ");

    return (
        <Box
            aria-label={accessibleLabel}
            sx={{
                alignItems: "center",
                backgroundColor: theme.custom.grey[100],
                borderColor: theme.custom.strokes.containerDivider.color,
                borderRadius: theme.spacing(0.5),
                display: "flex",
                minHeight: theme.spacing(4.5),
                padding: theme.spacing(0.75, 1),
                position: "relative",
            }}
        >
            <NumberWithUnit value={value} unit={unit} size="small" unitVariant="body-regular" />
            <Box
                aria-hidden
                sx={{
                    borderColor: "inherit",
                    borderRadius: "inherit",
                    borderStyle: theme.custom.strokes.containerDivider.style,
                    borderWidth: theme.custom.strokes.containerDivider.width,
                    inset: 0,
                    pointerEvents: "none",
                    position: "absolute",
                }}
            />
        </Box>
    );
};
